export default function getSlideInContainerClassName(slideInDirection: 'up' | 'down' | 'left' | 'right') {
    return `gb--slide-in-container gb--slide-in-${slideInDirection}`
}